<template>
<div class="fixed z-50 top-36 right-8 hidden 2xl:block">
  <a href="https://www.tbn.org.tw/" target="_blank" rel="noreferrer noopener"><div class="tbn test-picTBN"></div></a>
</div>
<div class="fixed z-50 bottom-40 right-0 2xl:hidden">
  <a href="https://www.tbn.org.tw/" target="_blank" rel="noreferrer noopener"><div class="tbn-small"></div></a>
</div>
<div class="fixed z-50 bottom-10 right-0">
  <a href="#introduction_href"><div class="top test-picTop"></div></a>
</div>
  <div class="absolute z-50 w-full">
    <Disclosure as="nav" v-slot="{ open }">
      <div class="max-w-7xl mx-auto px-10">
        <div class="absolute right-7 lg:hidden z-50 pt-7">
          <!-- Mobile menu button-->
          <DisclosureButton>
            <button v-if="!open"><img src="@/assets/nav.svg" alt="開啟導覽"/></button>
            <button v-else><img src="@/assets/nav-close.svg" alt="關閉導覽"/></button>
          </DisclosureButton>
        </div>
        <div class="hidden lg:flex justify-between w-full pt-12">
          <a
            v-for="item in navigation"
            :key="item.name"
            :href="item.href"
            class="hover:text-white text-lg font-black"
            :aria-current="item.current ? 'page' : undefined"
          >
            <span class="nav-btn-bg">{{ item.name }}</span>
          </a>
        </div>
      </div>
      <DisclosurePanel class="lg:hidden top-0 absolute w-full">
        <div class="nav-top"></div>
        <div class="nav-bg flex flex-col divide-y divide-gray-400 pt-10">
          <a
            v-for="item in navigation"
            :key="item.name"
            :href="item.href"
            class="
              hover:text-white
              text-lg
              font-black
              h-20
              flex flex-wrap
              content-center
              items-center
            "
            :aria-current="item.current ? 'page' : undefined"
          >
            <div class="ml-5 sm:ml-10"><img :src="item.icon" alt="導覽icon"/></div>
            <div class="ml-10">{{ item.name }}</div>
          </a>
        </div>
      </DisclosurePanel>
    </Disclosure>
  </div>
  <Introduction />
  <News />
  <Announcement />
  <Resources />
  <Links />
  <Policies />
  <Contacts />
</template>

<script>
import { ref } from "vue";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";

import Introduction from "@/views/main/Introduction.vue";
import News from "@/views/main/News.vue";
import Announcement from "@/views/main/Announcement.vue";
import Resources from "@/views/main/Resources.vue";
import Links from "@/views/main/Links.vue";
import Policies from "@/views/main/Policies.vue";
import Contacts from "@/views/main/Contacts.vue";

const navigation = [
  {
    icon: require("../../assets/introduction.svg"),
    name: "標本館介紹",
    href: "#introduction_href",
    current: true,
  },
  {
    icon: require("../../assets/news.svg"),
    name: "最新消息",
    href: "#news_href",
    current: false,
  },
  {
    icon: require("../../assets/resource.svg"),
    name: "線上資源",
    href: "#resources_href",
    current: false,
  },
  {
    icon: require("../../assets/link.svg"),
    name: "其他連結",
    href: "#links_href",
    current: false,
  },
  {
    icon: require("../../assets/policies.svg"),
    name: "使用條款及隱私權政策",
    href: "#policies_href",
    current: false,
  },
  {
    icon: require("../../assets/contact.svg"),
    name: "聯絡我們",
    href: "#contacts_href",
    current: false,
  },
];

export default {
  name: "Home",
  title: 'TAIE 農業部生物多樣性研究所植物標本館',
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Introduction,
    News,
    Announcement,
    Resources,
    Links,
    Policies,
    Contacts,
  },

  setup() {
    const open = ref(false);

    return {
      navigation,
      open,
    };
  },
};
</script>

<style scoped>
.nav-btn-bg {
  padding: 20px 25px;
  background-image: url("../../assets/btn-bg.svg");
}

.nav-top {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/nav-top.svg");
}

.top {
  width: 40px;
  height: 100px;
  background-image: url("../../assets/top.svg");
}

.top:hover {
  background-image: url("../../assets/top-hover.svg");
}

.tbn {
  width: 130px;
  height: 134px;
  background-image: url("../../assets/tbn.png");
}

.tbn:hover {
  background-image: url("../../assets/tbn-hover.png");
}

.tbn-small {
  width: 40px;
  height: 215px;
  background-image: url("../../assets/tbn.svg");
}

.tbn-small:hover {
  background-image: url("../../assets/tbn-hover.svg");
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .nav-bg {
    height: 555px;
    background-color: #ebe3db;
  }
}

@media (max-width: 639.98px) {
  .nav-bg {
    height: 455px;
    background-color: #ebe3db;
  }
}
</style>
